function setOptions(options, node, prefix, defaultLabel = '', defaultVal) {
  node.innerHTML = Object.keys(options)
    .map(key => {
      const value = `${prefix}${key}`
      const selected = defaultLabel === options[key] || defaultVal === value
      return `<option value="${value}"${selected ? ' selected="selected"' : ''}>${
        options[key]
      }</option>`
    })
    .join('')

  node.disabled = false
}

export default setOptions
